/**
 * Audience selection step toggle.
 * When true: audience UI is hidden; backend auto-selects first audience; user clicks Continue.
 * Set to false to restore manual audience picker in create/duplicate/continue flows.
 */
export const SKIP_AUDIENCE_SELECTION_STEP = true;

export function extractAudiencesFromList(audienceList) {
  if (!audienceList) return [];
  if (Array.isArray(audienceList)) return audienceList;
  if (
    typeof audienceList === "object" &&
    Array.isArray(audienceList.audiences)
  ) {
    return audienceList.audiences;
  }
  return [];
}

export function getFirstAudienceId(audiences) {
  if (!Array.isArray(audiences) || audiences.length === 0) return null;
  const id = audiences[0]?.id;
  return id != null && String(id).trim() !== "" ? String(id) : null;
}

export function resolveSelectedAudienceId(audiences, currentSelection) {
  const trimmed =
    currentSelection != null && String(currentSelection).trim() !== ""
      ? String(currentSelection).trim()
      : null;
  if (trimmed) return trimmed;
  if (SKIP_AUDIENCE_SELECTION_STEP) {
    return getFirstAudienceId(audiences);
  }
  return null;
}

/** Payload for generate-queries; audience is resolved on backend when skip mode is on. */
export function buildGenerateQueriesPayload(
  simulationId,
  { isNewSimulation = false, selectedAudience = null } = {},
) {
  const payload = {
    simulation_id: simulationId,
    is_new_simulation: isNewSimulation,
  };
  if (!SKIP_AUDIENCE_SELECTION_STEP && selectedAudience) {
    payload.selected_audience = String(selectedAudience);
  }
  return payload;
}
